//有头部和尾部
const router = [
  {
    path: "/home",
    meta: {
      title: "home",
    },
    component: (resolve) => require(["../views/home/index"], resolve),
  },
  // {
  // path: "/userCenter",
  // meta: {
  //   title: "个人中心",
  // },
  // component: (resolve) => require(["../views/userCenter/layout"], resolve),
  // children: [
  //   {
  //     path: "/userCenter/index",
  //     meta: {
  //       title: "个人首页",
  //     },
  //     component: (resolve) => require(["../views/userCenter/index"], resolve),
  //   },
  //   {
  //     path: "/userCenter/myPublish",
  //     meta: {
  //       title: "我发布的",
  //     },
  //     component: (resolve) =>
  //       require(["../views/userCenter/myPublish"], resolve),
  //   },
  //   {
  //     path: "/userCenter/order/orderList",
  //     meta: {
  //       title: "我的订单",
  //     },
  //     component: (resolve) =>
  //       require(["../views/userCenter/order/orderList"], resolve),
  //   },
  //   {
  //     path: "/userCenter/order/orderDetail",
  //     meta: {
  //       title: "订单详情",
  //     },
  //     component: (resolve) =>
  //       require(["../views/userCenter/order/orderDetail"], resolve),
  //   },
  // ],
  // },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js